import React, { useState } from "react";
import ScrollToTop from "../component/ScrollToTop";
import Header from "../component/Header";
import Footer from "../component/Footer";
import ContactModal from "../component/ContactModal";

export default function About() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      <ScrollToTop>
        <Header />
        <section className="hero_padding about_hero_section">
          <div className="container">
            <div className="row justify-content-center mb-md-5 mb-4 mt-md-0 mt-4">
              <div className="col-12">
                <h2 className="heading-2 text-center text-white">
                  Enabling growth with intelligent supply chain{" "}
                  <br className="d-md-block d-none" /> finance and payment
                  solutions
                </h2>
              </div>
            </div>
            <div className="row g-4">
              <div className="col-xl-3 col-sm-6 col-12">
                <div className="glass_stat_card">
                  <h2>$208b</h2>
                  <p>in transactions per year</p>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6 col-12">
                <div className="glass_stat_card">
                  <h2>33m</h2>
                  <p>accounts created yearly</p>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6 col-12">
                <div className="glass_stat_card">
                  <h2>3b</h2>
                  <p>transactions per year</p>
                </div>
              </div>
              <div className="col-xl-3 col-sm-6 col-12">
                <div className="glass_stat_card">
                  <h2>30m</h2>
                  <p>accounts migrated until 2024</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section_padding">
          <div className="container">
            <div className="row g-lg-5 g-4 align-items-center">
              <div className="col-lg-6">
                <h6 className="sub_para small_text fw-normal text-uppercase mb-xl-4">
                  Our Company
                </h6>
                <h2 className="heading-2 mb-xl-4 mb-3">Who we are</h2>
                <p className="sub_para">
                  Genxmeta Labs is a worldwide financial technology firm
                  developing ways to integrate the cryptocurrency market with
                  the established financial system.
                </p>
                <p className="sub_para">
                  We have been developing and enhancing our core blockchain and
                  web3 technologies since 2017 in an effort to bring web3 into
                  the public in a safe and legal manner.
                </p>
                <p className="sub_para">
                  Genxmeta Labs has operations in the UK and India and employs
                  more than 160 employees worldwide.
                </p>
              </div>
              <div className="col-lg-6 text-center text-lg-start">
                <img
                  src="/assets/639b830a4cbdd266bef3aa84_who-we-are.png"
                  alt="Who we are"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </section>
        <section className="section_padding about_vision_section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-6 col-lg-7 col-12">
                <div className="vision_glass_card">
                  <h6 className="sub_para small_text fw-normal text-uppercase text-cyan mb-xl-4 mb-2">
                    Our Vision
                  </h6>
                  <h2 className="heading-2 text-white mb-xl-4 mb-3">
                    Building the new <br className="d-lg-block d-none" /> economy
                  </h2>
                  <p className="sub_para text-light-grey mb-3">
                    Value creation and distribution are two more areas that are
                    being revolutionised by blockchain and tokenization.
                  </p>
                  <p className="sub_para text-light-grey mb-3">
                    We're using this tech to create a more fair and prosperous
                    economy that benefits everyone, not just the wealthy few.
                  </p>
                  <p className="sub_para text-light-grey mb-4">
                    Genxmeta Labs has operations in the UK and India and employs
                    more than 160 employees worldwide.
                  </p>
                  <h6 className="sub_para small_text fw-normal text-uppercase text-white-50 mb-3">
                    Member of
                  </h6>
                  <div className="d-flex gap-4 align-items-center logo_group">
                    <img
                      src="/assets/img/about/deo.png"
                      alt="DEO"
                      className="deo_img filter-bright"
                    />
                    <img src="/assets/img/about/web3.png" alt="Web3" className="filter-bright" />
                    <img src="/assets/img/about/eth.png" alt="Ethereum" className="filter-bright" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section_padding bg-blue">
          <div className="container">
            <div className="row g-lg-5 g-4">
              <div className="col-12 text-center">
                <h6 className="sub_para fw-normal text-uppercase mb-xl-4">
                  our values
                </h6>
                <h2 className="heading-2 mb-xl-5">What we believe in</h2>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="mb-4 blue_card">
                  <img
                    src="assets/img/about/Inclusive.svg"
                    alt=""
                    className=""
                  />
                </div>
                <h4 className="sub_heading mb-3">Inclusive</h4>
                <p className="sub_para">
                  To make web3 accessible to everyone, everywhere
                </p>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="mb-4 blue_card">
                  <img src="assets/img/about/Efficient.svg" alt="" />
                </div>
                <h4 className="sub_heading mb-3">Efficient</h4>
                <p className="sub_para">
                  To offer an automated and frictionless experience
                </p>
              </div>
              <div className="col-lg-3 col-md-6 ">
                <div className="mb-4 blue_card">
                  <img
                    src="assets/img/about/Reliable.svg"
                    alt=""
                    className=""
                  />
                </div>
                <h4 className="sub_heading mb-3">Reliable</h4>
                <p className="sub_para">
                  To be as transparent and verifiable as we can
                </p>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="mb-4 blue_card">
                  <img src="assets/img/about/Complaint.svg" alt="" />
                </div>
                <h4 className="sub_heading mb-3">Complaint</h4>
                <p className="sub_para">
                  To engage regulators and comply with existing rules
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="section_padding">
          <div className="container">
            <div className="row g-lg-5 g-4">
              <div className="col-lg-6">
                <h6 className="sub_para small_text fw-normal text-uppercase mb-xl-4">
                  our people's
                </h6>
                <h2 className="heading-2">Key Founders</h2>
                <p className="sub_para text_grey fw-normal">
                  Their visionary leadership has led Genxmeta Labs to the
                  forefront of the blockchain revolution, where trust is no
                  longer centralized but distributed across the network.
                </p>
              </div>
              <div className="col-lg-6">
                <div className="row g-3">
                  <div className="col-md-4 mb-2 mb-sm-0">
                    <img
                      src="/assets/img/about/about_avatar_1.jpg"
                      alt="Aman Vaths"
                      className="img-fluid rounded-4 shadow-sm"
                    />
                    <p className="sub_para mt-3 mb-0">Aman Vaths</p>
                    <span className="font_12 text_grey">CEO & Founder</span>
                    <div className="d-flex align-items-center mb-md-0 mb-2">
                      <a href="#" className="">
                        <img
                          src="/assets/img/639b830a4cbdd20fd5f3a9a9/linkdin.svg"
                          alt="linkdin"
                          className="image-3"
                        />
                      </a>
                      <a href="#" className="">
                        <img
                          src="/assets/img/639b830a4cbdd20fd5f3a9a9/twitter.svg"
                          alt="LinkedIn Link"
                          className="image-3 mt-1"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="col-md-4 mb-2 mb-sm-0">
                    <img
                      src="/assets/img/about/about_avatar_2.jpg"
                      alt="Sarah Jenkins"
                      className="img-fluid rounded-4 shadow-sm"
                    />
                    <p className="sub_para mt-3 mb-0">Sarah Jenkins</p>
                    <span className="font_12 text_grey">Co-Founder & CTO</span>
                    <div className="d-flex align-items-center mb-md-0 mb-2">
                      <a href="#" className="">
                        <img
                          src="/assets/img/639b830a4cbdd20fd5f3a9a9/linkdin.svg"
                          alt="linkdin"
                          className="image-3"
                        />
                      </a>
                      <a href="#" className="">
                        <img
                          src="/assets/img/639b830a4cbdd20fd5f3a9a9/twitter.svg"
                          alt="LinkedIn Link"
                          className="image-3 mt-1"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="col-md-4 mb-2 mb-sm-0">
                    <img
                      src="/assets/img/about/about_avatar_3.jpg"
                      alt="Marcus Sterling"
                      className="img-fluid rounded-4 shadow-sm"
                    />
                    <p className="sub_para mt-3 mb-0">Marcus Sterling</p>
                    <span className="font_12 text_grey">Co-Founder & Web3 Lead</span>
                    <div className="d-flex gap-2 align-items-center">
                      <a href="#" className="">
                        <img
                          src="/assets/img/639b830a4cbdd20fd5f3a9a9/linkdin.svg"
                          alt="linkdin"
                          className="image-3"
                        />
                      </a>
                      <a href="#" className="">
                        <img
                          src="/assets/img/639b830a4cbdd20fd5f3a9a9/twitter.svg"
                          alt="LinkedIn Link"
                          className="image-3 mt-1"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row g-lg-5 g-4 mt-md-5 mt-3">
              <div className="col-lg-6">
                <h6 className="sub_para small_text fw-normal text-uppercase mb-xl-4">
                  our company
                </h6>
                <h2 className="heading-2">Senior management</h2>
                <p className="sub_par text_grey fw-normal">
                  Our top management is made up of individuals with extensive
                  backgrounds in both traditional and cutting-edge sectors of
                  the business world.
                </p>
              </div>
              <div className="col-lg-6">
                <div className="row g-3">
                  <div className="col-md-4 mb-2 mb-sm-0">
                    <img
                      src="/assets/img/about/about_avatar_2.jpg"
                      alt="Elena Rostova"
                      className="img-fluid rounded-4 shadow-sm"
                    />
                    <p className="sub_para mt-3 mb-0">Elena Rostova</p>
                    <span className="font_12 text_grey">Head of AI Solutions</span>
                    <div className="d-flex align-items-center mb-md-0 mb-2">
                      <a href="#" className="">
                        <img
                          src="/assets/img/639b830a4cbdd20fd5f3a9a9/linkdin.svg"
                          alt="linkdin"
                          className="image-3"
                        />
                      </a>
                      <a href="#" className="">
                        <img
                          src="/assets/img/639b830a4cbdd20fd5f3a9a9/twitter.svg"
                          alt="LinkedIn Link"
                          className="image-3 mt-1"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="col-md-4 mb-2 mb-sm-0">
                    <img
                      src="/assets/img/about/about_avatar_1.jpg"
                      alt="David Kross"
                      className="img-fluid rounded-4 shadow-sm"
                    />
                    <p className="sub_para mt-3 mb-0">David Kross</p>
                    <span className="font_12 text_grey">Blockchain Lead</span>
                    <div className="d-flex align-items-center mb-md-0 mb-2">
                      <a href="#" className="">
                        <img
                          src="/assets/img/639b830a4cbdd20fd5f3a9a9/linkdin.svg"
                          alt="linkdin"
                          className="image-3"
                        />
                      </a>
                      <a href="#" className="">
                        <img
                          src="/assets/img/639b830a4cbdd20fd5f3a9a9/twitter.svg"
                          alt="LinkedIn Link"
                          className="image-3 mt-1"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="col-md-4 mb-2 mb-sm-0">
                    <img
                      src="/assets/img/about/about_avatar_3.jpg"
                      alt="Alex Mercer"
                      className="img-fluid rounded-4 shadow-sm"
                    />
                    <p className="sub_para mt-3 mb-0">Alex Mercer</p>
                    <span className="font_12 text_grey">Lead SaaS Architect</span>
                    <div className="d-flex gap-2 align-items-center">
                      <a href="#" className="">
                        <img
                          src="/assets/img/639b830a4cbdd20fd5f3a9a9/linkdin.svg"
                          alt="linkdin"
                          className="image-3"
                        />
                      </a>
                      <a href="#" className="">
                        <img
                          src="/assets/img/639b830a4cbdd20fd5f3a9a9/twitter.svg"
                          alt="LinkedIn Link"
                          className="image-3 mt-1"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="bg-blue section_padding">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <h2 className="heading-2">
                  Looking for development or collabration?
                </h2>
                <p className="sub_para">
                  Unlock the full potential of blockchain technology and joint
                  knowledge by requesting a price or calling us today.
                </p>
                <div className="d-flex justify-content-center gap-2">
                  <a href="tel:+918860132221" className="text-decoration-none" title="Call +91 88601 32221">
                    <div className="black-round">
                      <img src="assets/img/about/phone.svg" alt="Phone" />
                    </div>
                  </a>
                  <a href="mailto:us@genxmeta.com" className="text-decoration-none" title="Email us@genxmeta.com">
                    <div className="black-round">
                      <img src="assets/img/about/mail.svg" alt="Mail" />
                    </div>
                  </a>
                  <a href="https://www.facebook.com/Genxmeta" target="_blank" rel="noopener noreferrer" className="text-decoration-none" title="Facebook">
                    <div className="black-round">
                      <img src="/assets/img/639b830a4cbdd20fd5f3a9a9/facebook.svg" alt="Facebook" style={{ width: "20px", height: "20px" }} />
                    </div>
                  </a>
                  <a href="https://www.instagram.com/genxmetaofficial" target="_blank" rel="noopener noreferrer" className="text-decoration-none" title="Instagram">
                    <div className="black-round">
                      <img src="/assets/img/639b830a4cbdd20fd5f3a9a9/instagram.svg" alt="Instagram" style={{ width: "20px", height: "20px" }} />
                    </div>
                  </a>
                  <a href="https://www.linkedin.com/in/genx-meta/" target="_blank" rel="noopener noreferrer" className="text-decoration-none" title="LinkedIn">
                    <div className="black-round">
                      <img src="assets/img/about/linkedin.svg" alt="LinkedIn" />
                    </div>
                  </a>
                </div>
                <div className="d-flex justify-content-center pt-xl-4 pt-3">
                  <button
                    type="button"
                    onClick={() => setIsModalOpen(true)}
                    className="btn bg-black font_14 fw-bold px-3 text-white rounded"
                  >
                    Request for Demo
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
        <ContactModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      </ScrollToTop>
    </>
  );
}
